import Button from '@/common/components/Button'
import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { formatDate } from '@/common/utils/formatters'
import { BillingBillSupplyAuthorization } from '@/features/billingBills/types/billingBillSupplyAuthorization.type'
import { billingSupplyAuthorizationStatus } from '@/features/supplyAuthorizations/constants/billingSupplyAuthorizationStatus.constant'
import { ArrowRightToLineIcon, User2Icon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class BillingBillSupplyAuthorizationTransformer {
  static tableTransformer() {
    return (supplyAuthorizations: BillingBillSupplyAuthorization[]) => {
      return supplyAuthorizations.map((supplyAuthorization) => {
        return {
          ...supplyAuthorization,
          status: billingSupplyAuthorizationStatus[supplyAuthorization.status],
          author: supplyAuthorization?.creator ? (
            <ImageWithDisplayName
              placeholderIcon={User2Icon}
              imageUrl={supplyAuthorization?.creator?.profile_picture?.url}
              displayName={supplyAuthorization?.creator?.full_name}
            />
          ) : (
            ''
          ),
          created_at: formatDate(new Date(supplyAuthorization?.created_at || 0)),
          actions: (
            <Link to={`/supply-authorizations/${supplyAuthorization.id}`}>
              <Button
                className="bg-transparent hover:bg-transparent disabled:hover:bg-transparent p-0"
                operationKlassToCheckPermission="Client::Billing::SupplyAuthorizations::Show"
              >
                <ArrowRightToLineIcon strokeWidth={1} />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
